<template>
  <iframe :src="webUrl+'/admin/platform/bmtk'"></iframe>
</template>

<script>
export default {
  name: "confidentiality",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>